<template>
    <app-base-main headFixed v-loading="loading">
      <template #filter-group>
        <app-filter-group
          :reset="false"
          :query="false">
          <gj-market-select
            v-model="filter.marketId"
            init-value
            :clearable="false"
            width="130px"
            @input-option="selectInput"
        ></gj-market-select>
        <gj-button
            type="primary"
            style="height: 32px;"
            @click="synchronization">
            同步
          </gj-button>
          <template #right>
            <gj-tool-group help></gj-tool-group>
          </template>
        </app-filter-group>
      </template>
      <template #base-content >
          <gj-empty class="content-empty" v-if="!pageDetails.serves && !pageDetails.commodityPolicies && !pageDetails.distributions" text="暂无数据"></gj-empty>
          <div v-else-if="!loading">
            <div class="details-cell">
              <PromptMessage :updateTime="pageDetails.dateTime"/>
              <StorePerformance :pageDetails="pageDetails" @anchorRoll="anchorRoll"/>
            </div>
            <div class="details-cell" id="customer-service">
              <CustomerService :serves="pageDetails.serves"/>
            </div>
            <div class="details-cell" id="product-compliance">
              <ProductCompliance :commodityPolicies="pageDetails.commodityPolicies"/>
            </div>
            <div class="details-cell" id="distribution-performance">
              <DistributionPerformance :distributions="pageDetails.distributions"/>
            </div>
          </div>
      </template>
    </app-base-main>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import PromptMessage from "../components/prompt-message.vue";
import StorePerformance from "./components/store-performance";
import CustomerService from "./components/customer-service";
import DistributionPerformance from "./components/distribution-performance";
import ProductCompliance from "./components/product-compliance";
import { executeSyncJob, performanceDetail } from "@/api/statistics"

export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  components: {
    PromptMessage, StorePerformance, CustomerService, DistributionPerformance, ProductCompliance
  },
  data() {
    return {
      loading: false,
      filter: {
        marketId: null,
        countryCode: null,
        createDate: null,
      },
      pageDetails: {
        commodityPolicies: null, // 政策合规性数据
        distributions: null, // 配送绩效数据
        serves: null, // 客户服务绩效数据
        dateTime: ""
      },
      anchorRollId: ""
    }
  },
  methods: {
    // 同步
    async synchronization() {
      this.loading = true
      try {
        await executeSyncJob()
        this.performanceDetail()
      } finally {
        this.loading = false
      }
    },
    async performanceDetail() {
      let marketId = this.filter.marketId
      let countryCode = this.filter.countryCode
      if (!marketId || !countryCode) { return false }
      this.loading = true
      try {
        let { commodityPolicies, distributions, serves, dateTime } = await performanceDetail(marketId, countryCode)
        this.pageDetails.commodityPolicies = commodityPolicies;
        this.pageDetails.distributions = distributions;
        this.pageDetails.serves = serves;
        this.pageDetails.dateTime = dateTime;
      } finally {
        this.loading = false
        if (this.anchorRollId) {
          setTimeout(() => {
            this.anchorRoll(this.anchorRollId)
            sessionStorage.setItem("anchorRoll", "");
          }, 100);
        }
      }
    },
    // 店铺change
    selectInput(val) {
      this.filter.countryCode = val.countryCode
      this.performanceDetail()
    },
    // 锚点滚动事件
    anchorRoll(id) {
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
    },
  },
  created() {
    this.anchorRollId = sessionStorage.getItem("anchorRoll");
    if (this.$route.query.marketId) {
      this.filter.marketId = this.$route.query.marketId
      this.filter.countryCode = this.$route.query.countryCode
      this.performanceDetail()
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.filter-group {
  padding:0 20px;
  width: calc(100% - 40px);
}
.content-empty {
  width: 160px;
  height: 160px;
  margin: 180px auto;
}
.details-cell {
  background: #fff;
  margin-bottom: 15px;
}
/deep/ .base-content{
  &::-webkit-scrollbar-track{
    background: #fff;
  }
}
</style>
